import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { ButtonColor } from "../button/button.component";

@Component({
    selector: "app-confirmation-popup",
    templateUrl: "./confirmation-popup.component.html",
    styleUrls: ["./confirmation-popup.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationPopupComponent {
  @Input() title: string = "";
  @Input() description: string = "";
  @Input() confirmButtonLabel: string = "Confirm";
  @Input() cancelButtonLabel: string = "Cancel";
  @Input() confirmButtonColor: ButtonColor = "primary";
  @Input() cancelButtonColor: ButtonColor = "secondary";
  @Input() showPopup: boolean = false;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }

  onClose() {
    this.close.emit();
  }
}
